import React, { Component, Fragment, ReactNode } from 'react'
import inventoryCaseApi, { CaseData, CaseTransferRequest } from '../../apis/inventoryCase.api'
import palletApi, { PalletData } from '../../apis/pallet.api'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import alertService from '../../services/alert.service'
import confirmService from '../../services/confirm.service'
import CardButton from '../../components/CardButton'
import Row from '../../components/Row/Row'
import InputScan from '../../components/InputScan'
import { i18n } from '../../i18n/i18n'
import Checkbox from '../../components/Checkbox'

interface Props {
  selectedCases: number[]
  children: ReactNode
  onSourcePalletChange: (pallet: PalletData | null) => void
  onCaseScan: (inventoryCase: CaseData) => void
  onResetForm: () => void
}

interface State {
  sourcePalletCode: string
  targetPalletCode: string
  caseCode: string
  inventoryCase: CaseData | null
  sourcePallet: PalletData | null
  targetPallet: PalletData | null
  isMixed: boolean
}

export default class TransferToPallet extends Component<Props, State> {
  initialState: State = {
    sourcePalletCode: '',
    targetPalletCode: '',
    caseCode: '',
    isMixed: false,
    inventoryCase: null,
    sourcePallet: null,
    targetPallet: null
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleInputScan = this.handleInputScan.bind(this)
    this.handleTransferClick = this.handleTransferClick.bind(this)
    this.handleIsMixedChange = this.handleIsMixedChange.bind(this)
  }

  handleInputChange (name: string, value: string) {
    if (name === 'sourcePalletCode') {
      this.setState({ sourcePalletCode: value })
    } else if (name === 'targetPalletCode') this.setState({ targetPalletCode: value })
    else if (name === 'caseCode') this.setState({ caseCode: value })
  }

  readSourcePallet (code: string) {
    if (!code) return
    palletApi.readByCode(code, sourcePallet => {
      this.setState({ sourcePallet })
      this.props.onSourcePalletChange(sourcePallet)
    })
  }

  readTargetPallet (code: string) {
    if (!code) return
    palletApi.readByCode(code, targetPallet => {
      this.setState({ targetPallet })
    })
  }

  handleCaseScan (code: string) {
    if (!code) return
    inventoryCaseApi.readByCode(code, inventoryCase => {
      if (!inventoryCase) return
      this.setState({ inventoryCase, caseCode: '' })
      this.props.onCaseScan(inventoryCase)
    })
  }

  handleInputScan (name: string, value: string) {
    if (name === 'sourcePalletCode') {
      this.readSourcePallet(value)
    } else if (name === 'targetPalletCode') {
      this.readTargetPallet(value)
    } else if (name === 'caseCode') {
      this.handleCaseScan(value)
    }
  }


  handleIsMixedChange () {
    this.setState({ isMixed: !this.state.isMixed });
  }

  reset () {
    this.setState({
      sourcePalletCode: '',
      targetPalletCode: '',
      isMixed: false,
      sourcePallet: null,
      targetPallet: null
    })
    this.props.onResetForm()
  }

  handleTransferConfirm () {
    const { sourcePallet, targetPallet, isMixed } = this.state
    const payload: CaseTransferRequest = {
      isMixed: isMixed
    }
    const { selectedCases } = this.props
    if (sourcePallet) payload.sourcePallet = sourcePallet.id
    if (targetPallet) payload.targetPallet = targetPallet.id
    if (selectedCases) payload.cases = selectedCases
    inventoryCaseApi.transfer(payload, pallet => {
      if (!pallet) return
      alertService.success('Successfully transferred')
      this.reset()
    })
  }

  handleTransferClick () {
    const confirm: ConfirmParams = {
      id: 1,
      question: i18n('Please review and confirm transfer.'),
      confirmText: i18n('Confirm'),
      cancelText: i18n('Cancel'),
      onConfirm: () => this.handleTransferConfirm()
    }
    confirmService.push(confirm)
  }

  render () {
    return (
      <Fragment>
        <Row column={1}>
          <hr className="mb-4"></hr>
          <div className="flex">
            <Checkbox
              name="isMixed"
              checked={this.state.isMixed}
              onChange={this.handleIsMixedChange}
              className="" /> 
              <span className='mt-1 ml-1'>{i18n("Allow mixed items")}</span>
          </div>
          <hr className='mb-4'></hr>
        </Row>
        <Row column={2} >
          <InputScan
            name="sourcePalletCode"
            value={this.state.sourcePalletCode}
            label={i18n("Scan source pallet code")}
            autofocus={true}
            onChange={this.handleInputChange}
            onScan={this.handleInputScan} />
          <InputScan
            name="targetPalletCode"
            value={this.state.targetPalletCode}
            label={i18n("Scan target pallet code")}
            onChange={this.handleInputChange}
            onScan={this.handleInputScan} />
        </Row>
        {this.props.children}
        <Row column={2}>
          <InputScan
            name="caseCode"
            value={this.state.caseCode}
            label={i18n("Scan case code")}
            onChange={this.handleInputChange}
            onScan={this.handleInputScan} />
        </Row>
        <CardButton
          proceedText={i18n("Transfer")}
          onProceedClick={this.handleTransferClick} />
      </Fragment>
    )
  }
}